/*
 * @Description: What's this for
 * @Autor: WangYuan
 * @Date: 2021-05-19 09:49:33
 * @LastEditors: WangYuan
 * @LastEditTime: 2021-10-08 16:34:09
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

Vue.use(VueRouter)

const routes = [{
		path: '/',
		redirect: '/index'
	},

	{
		path: '/index',
		name: 'index',
		component: () => import('@/views/index/index.vue'),
	},
	{
		path: '/solution',
		name: 'solution',
		meta: {
			title: '解决方案'
		},

		component: () => import('@/views/solution/solution.vue'),
	},
	{
		path: '/coreBusiness',
		name: 'coreBusiness',
		meta: {
			title: '核心业务'
		},
		component: () => import('@/views/coreBusiness/coreBusiness.vue'),
	},
	{
		path: '/assetDatabase',
		name: 'assetDatabase',
		meta: {
			title: '资产数据库'
		},
		component: () => import('@/views/assetDatabase/assetDatabase.vue'),
	},
	{
		path: '/about',
		name: 'about',
		meta: {
			title: '关于我们'
		},
		component: () => import('@/views/about/about.vue'),
	},
	{
		path: '/assetdetail',
		name: 'assetdetail',
		meta: {
			title: '资产详情'
		},
		component: () => import('@/views/assetdetail/assetdetail.vue'),
	},
	{
		path: '/detail',
		name: 'detail',
		meta: {
			title: '详情页'
		},
		component: () => import('@/views/detail/detail.vue'),
	},
	{
		path: '/doclist',
		name: 'doclist',
		meta: {
			title: '新闻动态'
		},
		component: () => import('@/views/doclist/doclist.vue'),
	},
	{
		path: '/userCenter/index',
		name: 'userCenter',
		meta: {
			title: '个人中心'
		},
		component: () => import('@/views/userCenter/index/index.vue'),
	},
	{
		path: '/userCenter/workRegistration',
		name: 'workRegistration',
		meta: {
			title: '作品登记'
		},
		component: () => import('@/views/userCenter/workRegistration/workRegistration.vue'),
	},
	{
		path: '/userCenter/mywork',
		name: 'mywork',
		meta: {
			title: '我的作品'
		},
		component: () => import('@/views/userCenter/mywork/mywork.vue'),
	},
	{
		path: '/userCenter/vipService',
		name: 'vipService',
		meta: {
			title: '会员服务'
		},
		component: () => import('@/views/userCenter/vipService/vipService.vue'),
	},
	{
		path: '/bindpage/wechart',
		name: 'bindwechart',
		meta: {
			title: '微信帐号绑定'
		},
		component: () => import('@/views/bindpage/wechart.vue'),
	},
	{
		path: '/bindpage/alipay',
		name: 'bindalipay',
		meta: {
			title: '支付宝帐号绑定'
		},
		component: () => import('@/views/bindpage/alipay.vue'),
	},
	{
		path: '/userCenter/userinfo',
		name: 'userinfo',
		meta: {
			title: '个人信息'
		},
		component: () => import('@/views/userCenter/userinfo/userinfo.vue'),
	},
	{
		path: '/userCenter/userbind',
		name: 'userbind',
		meta: {
			title: '账户绑定'
		},
		component: () => import('@/views/userCenter/userbind/userbind.vue'),
	},

]

const router = new VueRouter({
	mode: 'history', // 👈 关键：启用 history 模式
	linkActiveClass: 'active',
	base: process.env.BASE_URL,
	routes
})

// 全局路由守卫鉴权
router.beforeEach((to, from, next) => {
	next()
	var pagetitle = to.meta.title
	if (pagetitle) {
		document.title = to.meta.title + "-环太湖艺术动产" 
	} else {
		document.title = "环太湖艺术动产"
	}
	window.scrollTo(0, 0);
	// chrome 
	document.body.scrollTop = 0
	// firefox
	document.documentElement.scrollTop = 0
	// safari window.pageYOffset = 0 
	// if (to.name == 'login') {
	//   next()
	// } else {
	//   if (!store.getters.token) {
	//     next('/')
	//   } else {
	//     next()
	//   }
	// }
})
export default router